import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participantesso2',
  templateUrl: './participantesso2.component.html',
  styleUrls: ['./participantesso2.component.scss']
})
export class Participantesso2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
